import * as React from "react";
import { Link } from "react-router-dom";

import { Page, PageHero, Tabs } from "src/components/common";
import DatasetContext from "src/context/DatasetContext";

interface IProps {
	children?: any;
	match?: any;
	location?: any;
}

const OrganizationDatasetsTabs: React.FC<IProps> = (props) => {
	const [title, setTitle] = React.useState("");
	const datasetContext = React.useContext(DatasetContext);

	const tabs = [
		{
			id: 1,
			to: {
				pathname: `/admin/organizations/${props.match.params.organizationId}/datasets/${props.match.params.datasetId}/details`,
			},
			label: "Details",
		},
	];
	if (props.match.params.datasetId !== "-1") {
		tabs.push(
			{
				id: 2,
				to: {
					pathname: `/admin/organizations/${props.match.params.organizationId}/datasets/${props.match.params.datasetId}/locations`,
				},
				label: "Locations",
			},
			{
				id: 3,
				to: {
					pathname: `/admin/organizations/${props.match.params.organizationId}/datasets/${props.match.params.datasetId}/users`,
				},
				label: "Users",
			},
			{
				id: 4,
				to: {
					pathname: `/admin/organizations/${props.match.params.organizationId}/datasets/${props.match.params.datasetId}/cutpoints`,
				},
				label: "Cutpoints",
			},
			{
				id: 5,
				to: {
					pathname: `/admin/organizations/${props.match.params.organizationId}/datasets/${props.match.params.datasetId}/report-settings`,
				},
				label: "Branding",
			},
			{
				id: 6,
				to: {
					pathname: `/admin/organizations/${props.match.params.organizationId}/datasets/${props.match.params.datasetId}/personal-fields`,
				},
				label: "PII Fields",
			},
			{
				id: 7,
				to: {
					pathname: `/admin/organizations/${props.match.params.organizationId}/datasets/${props.match.params.datasetId}/billing`,
				},
				label: "Billing",
			}
		);
	}

	return (
		<Page>
			<PageHero>
				<Link
					to={`/admin/organizations/${props.match.params.organizationId}/datasets`}
				>
					&lt; DATASETS
				</Link>
				<h1 className="mb-0">
					{" "}
					{props.match.params.datasetId !== "-1"
						? datasetContext.currentDataset.name ||
						  localStorage.getItem("currentDatasetName")
						: "New"}{" "}
					Dataset
				</h1>
			</PageHero>
			<Tabs className="mb-4" tabs={tabs} location={props.location} />
			{props.children}
		</Page>
	);
};

export default OrganizationDatasetsTabs;
